import RequestAbstract from "../abstract";

export default class AccountingRevenueTransactions extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/accounting-revenue-transactions";
    }

}
